import { kcMessages } from "keycloakify/lib/i18n/useKcMessage";

Object.assign(
	kcMessages["fr"],
	{
		/* spell-checker: disable */
		"foo": "foo en Francais",
		/* spell-checker: enable */
	}
);

Object.assign(
	kcMessages["en"],
	{
		"foo": "foo in English",
		"noAccount": "Don't have an account? ",
		"doRegister": "Sign Up for Free",
		"updatePasswordTitle": "Reset your password",
		"backToLogin": "« Back to Sign In",
		"doSubmit": "Submit",
		"backToApplication": "« Back to Dashboard",
		"accountUpdatedMessage": "Your password has been updated"
	}
);
